import { Injectable, NgZone } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
  HttpStatusCode
} from '@angular/common/http';
import { catchError, Observable, throwError, tap, from, switchMap } from 'rxjs';
import { SessionValues } from './services/sessionvalues.service';
import { AppStateManageService } from './services/app-state-manage.service';
import { UIUtils } from './services/uiutils.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthService } from './shared/services';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { AppTypes } from './classes/infrastructure/enums';
import { ServerCommunicatorService } from './services/server-communicator.service';

@Injectable()
export class LoginTokenInterceptor implements HttpInterceptor {

  private isPopupOpen = false;

  constructor(
    private sessionValues: SessionValues,
    private appStateManage: AppStateManageService,
    private alertController: AlertController,
    private uiUtils: UIUtils,
    private router: Router,
    private zone: NgZone, private authService: AuthService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let authToken = this.sessionValues.CurrentLoginToken;
    let Role = this.appStateManage.getRole();
    let RoleName = this.appStateManage.getRoleName();
    let LoginUserRef = this.appStateManage.getLoginUserRef();
    let AppType = AppTypes.Web;
    let PlatForm = '';

    const setHeaders = {
      Authorization: '',
      Role: Role.toString(),
      RoleName: RoleName,
      LoginUserRef: LoginUserRef.toString(),
      AppType: AppType.toString(),
      Platform: PlatForm
    }

    if (authToken) {
      setHeaders.Authorization = `Bearer ${authToken}`;
    }

    request = request.clone({ setHeaders })

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        console.log('error :', err);
        // // debugger
        // if (error.status === 423 && error.error?.Payload) {

        //   let payload: any;
        //   try {
        //     payload = JSON.parse(error.error.Payload);
        //   } catch {
        //     return throwError(() => error);
        //   }

        //   if (payload.Tag === 'PasswordHasExpired') {
        //     this.uiUtils.showErrorMessageForPasswordExpire(
        //       'Password Expired',
        //       'Please change your password to continue.'
        //     );
        //   }
        // }

        // else 
        if (err.status === HttpStatusCode.Unauthorized) {

          if (this.isPopupOpen) {
            // return throwError(() => err);

            return from(
              this.showErrorMessageForSessionExpire(
                err.statusText,
                err.error
              )
            ).pipe(
              tap(() => {
                if (authToken) {
                  ServerCommunicatorService.GetInstance().ResetDataAfterLogout();
                  this.router.navigate(['/login-form']);
                }
                else {
                  this.router.navigate(['/login-form']);
                }
              }),
              // After handling, still return error to caller
              switchMap(() => throwError(() => err))
            );
          }

          this.isPopupOpen = true;

          let payload: any = null;

          if (err.error) {
            try {
              payload = JSON.parse(err.error);
            } catch (e) {
              console.log('Payload parse error:', e);
            }
          }

          const tag = payload?.Tag?.replace(/"/g, '');


          return from(
            this.showErrorMessageForSessionExpire(
              err.statusText,
              err.error
            )
          ).pipe(
            tap(() => {
              if (authToken) {
                this.authService.logOut().then(() => {
                  this.router.navigate(['/login-form']);
                });
              }
              else {
                this.router.navigate(['/login-form']);
              }
            }),
            // After handling, still return error to caller
            switchMap(() => throwError(() => err))
          );
        }


        // else if (err.status === HttpStatusCode.UpgradeRequired) {
        //   const playStoreUrl =
        //     'https://play.google.com/store/search?q=flipkart&c=apps&hl=en_IN';

        //   if (this.isPopupOpen) {
        //     // return throwError(() => err);

        //     return from(
        //       this.showErrorMessageForSessionExpire(
        //         err.statusText,
        //         err.error
        //       )
        //     ).pipe(
        //       tap(() => {
        //         if (authToken) {
        //           ServerCommunicatorService.GetInstance().ResetDataAfterLogout();
        //           // window.open(playStoreUrl, '_system');
        //           this.router.navigate(['/login-form']);
        //         }
        //         else {
        //           // window.open(playStoreUrl, '_system');
        //           this.router.navigate(['/login-form']);
        //         }
        //       }),
        //       // After handling, still return error to caller
        //       switchMap(() => throwError(() => err))
        //     );
        //   }

        //   this.isPopupOpen = true;

        //   let payload: any = null;

        //   if (err.error) {
        //     try {
        //       payload = JSON.parse(err.error);
        //     } catch (e) {
        //       console.log('Payload parse error:', e);
        //     }
        //   }

        //   const tag = payload?.Tag?.replace(/"/g, '');


        //   return from(
        //     this.showErrorMessageForSessionExpire(
        //       err.statusText,
        //       err.error
        //     )
        //   ).pipe(
        //     tap(() => {
        //       if (authToken) {
        //         this.authService.logOut().then(() => {
        //           // window.open(playStoreUrl, '_system');
        //           this.router.navigate(['/login-form']);
        //           });
        //       }
        //       else {
        //         // window.open(playStoreUrl, '_system');
        //         this.router.navigate(['/login-form']);
        //       }
        //     }),
        //     // After handling, still return error to caller
        //     switchMap(() => throwError(() => err))
        //   );
        // }



        // ✅ Always return HttpEvent type
        return throwError(() => err);
      })
    );


  }
  public async showErrorMessageForSessionExpire(
    title: string,
    msg: string
  ): Promise<void> {

    await Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: true
    });

  }
}